/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ScadenzaVigileDto } from '../../models/scadenza-vigile-dto';

export interface ApiScadenzeScadenzeVigileListGet$Params {}

export function apiScadenzeScadenzeVigileListGet(
    http: HttpClient,
    rootUrl: string,
    params?: ApiScadenzeScadenzeVigileListGet$Params,
    context?: HttpContext,
): Observable<StrictHttpResponse<Array<ScadenzaVigileDto>>> {
    const rb = new RequestBuilder(rootUrl, apiScadenzeScadenzeVigileListGet.PATH, 'get');
    if (params) {
    }

    return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<Array<ScadenzaVigileDto>>;
        }),
    );
}

apiScadenzeScadenzeVigileListGet.PATH = '/api/scadenze/scadenze-vigile-list';
